import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { SupportComponent } from '@lib/components/support-class';
import { isPC } from '@lib/helpers';
import { CommonLibService } from '@lib/services';
import { fromEvent, throttleTime } from 'rxjs';

/**
 * 積算マイル
 */
@Component({
  selector: 'asw-plan-review-accrual-miles',
  templateUrl: './plan-review-accrual-miles.component.html',
  styleUrls: ['./plan-review-accrual-miles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanReviewAccrualMilesComponent extends SupportComponent {
  @Input() isPlanValid = false;
  @Input() accrualMiles = 0;

  /** 画面サイズ判定(PC) */
  public isPC = isPC();

  /** 画面サイズ比較用変数(SP) */
  public isPCPre = this.isPC;

  /** 画面サイズチェック用関数 */
  private _resizeEvent = () => {
    this.isPCPre = this.isPC;
    this.isPC = isPC();
    if (this.isPCPre !== this.isPC) {
      this._changeDetectorRef.markForCheck();
    }
  };

  constructor(private _common: CommonLibService, private _changeDetectorRef: ChangeDetectorRef) {
    super(_common);
  }

  init(): void {
    // 画面サイズチェック開始
    this.subscribeService(
      'PlanReviewAccrualMilesResize',
      fromEvent(window, 'resize').pipe(throttleTime(500)),
      this._resizeEvent
    );
  }

  reload(): void {}

  destroy(): void {
    this.deleteSubscription('PlanReviewAccrualMilesResize');
  }
}
